export enum BulkAction {
    DELETE = 'delete',
}
